var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketlaunch1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_3336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.00004 10.2715C3.44671 10.2715 2.94671 10.4981 2.58671 10.8581C1.80004 11.6448 1.33337 14.9381 1.33337 14.9381C1.33337 14.9381 4.62671 14.4715 5.41337 13.6848C5.77337 13.3248 6.00004 12.8248 6.00004 12.2715C6.00004 11.1648 5.10671 10.2715 4.00004 10.2715ZM4.47337 12.7448C4.28671 12.9315 3.02671 13.2515 3.02671 13.2515C3.02671 13.2515 3.34004 11.9981 3.53337 11.8048C3.64671 11.6781 3.81337 11.6048 4.00004 11.6048C4.36671 11.6048 4.66671 11.9048 4.66671 12.2715C4.66671 12.4581 4.59337 12.6248 4.47337 12.7448ZM11.6134 9.37148C15.8534 5.13148 14.44 1.83148 14.44 1.83148C14.44 1.83148 11.14 0.418147 6.90004 4.65815L5.24004 4.32481C4.80671 4.23815 4.35337 4.37815 4.03337 4.69148L1.33337 7.39815L4.66671 8.82481L7.44671 11.6048L8.87337 14.9381L11.5734 12.2381C11.8867 11.9248 12.0267 11.4715 11.94 11.0315L11.6134 9.37148ZM4.94004 7.49148L3.66671 6.94481L4.98004 5.63148L5.94004 5.82481C5.56004 6.37815 5.22004 6.95815 4.94004 7.49148ZM9.32671 12.6048L8.78004 11.3315C9.31337 11.0515 9.89337 10.7115 10.44 10.3315L10.6334 11.2915L9.32671 12.6048ZM10.6667 8.43148C9.78671 9.31148 8.41337 10.0315 7.97337 10.2515L6.02004 8.29815C6.23337 7.86481 6.95337 6.49148 7.84004 5.60481C10.96 2.48481 13.3267 2.94481 13.3267 2.94481C13.3267 2.94481 13.7867 5.31148 10.6667 8.43148ZM10 7.60481C10.7334 7.60481 11.3334 7.00481 11.3334 6.27148C11.3334 5.53815 10.7334 4.93815 10 4.93815C9.26671 4.93815 8.66671 5.53815 8.66671 6.27148C8.66671 7.00481 9.26671 7.60481 10 7.60481Z",
    fill: "#17A34A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_3336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.271484)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketlaunch1);
export default __webpack_public_path__ + "static/media/Rocket launch1.aff505d7d0ae440905e4854a65a23b70.svg";
export { ForwardRef as ReactComponent };